var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPenLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.875 23.375H27.125V25.25H0.875V23.375ZM22.8125 7.4375C23.5625 6.6875 23.5625 5.5625 22.8125 4.8125L19.4375 1.4375C18.6875 0.6875 17.5625 0.6875 16.8125 1.4375L2.75 15.5V21.5H8.75L22.8125 7.4375ZM18.125 2.75L21.5 6.125L18.6875 8.9375L15.3125 5.5625L18.125 2.75ZM4.625 19.625V16.25L14 6.875L17.375 10.25L8 19.625H4.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPenLight);
export default __webpack_public_path__ + "static/media/edit-pen-light.fa954dc3350c788084ce11e758b139ba.svg";
export { ForwardRef as ReactComponent };